import {
  ISSUE_FIELD_DATE_VALUE_TYPE,
  ISSUE_FIELD_MULTI_SELECT_VALUE_TYPE,
  ISSUE_FIELD_NUMBER_VALUE_TYPE,
  ISSUE_FIELD_SINGLE_SELECT_VALUE_TYPE,
  ISSUE_FIELD_TEXT_VALUE_TYPE,
} from '@github-ui/issue-fields-shared/issue-field'
import type {RecordProxy, RecordSourceSelectorProxy} from 'relay-runtime'

import type {IssueFieldCreateOrUpdateInput} from './__generated__/updateIssueFieldValueMutation.graphql'

// Helper to get field value type based on input
export const getFieldValueType = (
  fieldInput: Pick<
    IssueFieldCreateOrUpdateInput,
    'singleSelectOptionId' | 'multiSelectOptionIds' | 'dateValue' | 'numberValue'
  >,
) => {
  if (fieldInput.singleSelectOptionId !== undefined) return ISSUE_FIELD_SINGLE_SELECT_VALUE_TYPE
  if (fieldInput.multiSelectOptionIds !== undefined) return ISSUE_FIELD_MULTI_SELECT_VALUE_TYPE
  if (fieldInput.dateValue !== undefined) return ISSUE_FIELD_DATE_VALUE_TYPE
  if (fieldInput.numberValue !== undefined) return ISSUE_FIELD_NUMBER_VALUE_TYPE
  return ISSUE_FIELD_TEXT_VALUE_TYPE
}

// Helper to update node values
export const updateNodeValues = (
  store: RecordSourceSelectorProxy,
  node: ReturnType<RecordSourceSelectorProxy['get']> | null,
  fieldInput: IssueFieldCreateOrUpdateInput,
) => {
  if (!node) return
  if (fieldInput.textValue !== undefined) node.setValue(fieldInput.textValue, 'value')
  if (fieldInput.singleSelectOptionId !== undefined && fieldInput.singleSelectOptionId !== null) {
    const options = store.get(fieldInput.fieldId)?.getLinkedRecords('options') || []
    const found = options.find(opt => opt.getDataID() === fieldInput.singleSelectOptionId)
    node.setValue(found?.getValue('name') ?? null, 'name')
    node.setValue(found?.getValue('color') ?? null, 'color')
    node.setValue(found?.getValue('description') ?? null, 'description')
  }
  if (fieldInput.multiSelectOptionIds !== undefined && fieldInput.multiSelectOptionIds !== null) {
    const fieldOptions = store.get(fieldInput.fieldId)?.getLinkedRecords('options') || []
    const selectedIds = new Set(fieldInput.multiSelectOptionIds)
    const selectedOptions = fieldOptions.filter(opt => opt && selectedIds.has(opt.getDataID()))
    node.setLinkedRecords(selectedOptions, 'options')
  }
  if (fieldInput.dateValue !== undefined) node.setValue(fieldInput.dateValue, 'value')
  if (fieldInput.numberValue !== undefined) node.setValue(fieldInput.numberValue, 'value')
}

// Helper to replace or add a field value node in the collection
export const replaceFieldValueInCollection = (
  fieldValues: ReturnType<RecordSourceSelectorProxy['get']>,
  fieldId: string,
  newNode: NonNullable<ReturnType<RecordSourceSelectorProxy['get']>>,
) => {
  if (!fieldValues || !newNode) return
  const nodes = fieldValues.getLinkedRecords('nodes') || []
  const updatedNodes = nodes.filter(n => n?.getLinkedRecord('field')?.getDataID() !== fieldId)
  updatedNodes.push(newNode as RecordProxy)
  fieldValues.setLinkedRecords(updatedNodes, 'nodes')
}
